import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import storageX from "../storageCore/storageX";
import {
  STORAGE_KEY_ACCESS_TOKEN_KEYCLOAK,
  STORAGE_KEY_ACCESS_TOKEN_WSO2,
} from "../storageCore/constStorageKeys";
import { PageEvent } from "@angular/material/paginator";
import { StepUpTokenStore } from "../services/step-up-token.store";

export interface GatewayHeadersOptions {
  /** Quando false, não consome o token de step-up (ex.: POST /auth/step-up). */
  consumeStepUp?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class HttpUtil {
  token: any;
  clientId: any;

  constructor(private stepUpStore: StepUpTokenStore) {}

  buildPaginator(page: PageEvent, sort: string): Map<string, string> {
    const params = new Map();
    params.set("page", page.pageIndex);
    params.set("size", page.pageSize);
    params.set("sort", sort);
    return params;
  }
  buildHeadersGateway(options?: GatewayHeadersOptions): HttpHeaders {
    let headers = new HttpHeaders();

    if (this.token !== "" && this.clientId !== "") {
      headers = headers.append(
        "Authorization",
        "Bearer " + storageX.whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_WSO2).get()
      );
    }

    headers = headers.set("Accept", "application/hal+json, application/json");
    const consumeStepUp = !options || options.consumeStepUp !== false;
    const stepUpToken = consumeStepUp ? this.stepUpStore.getAndClear() : null;
    const keycloakToken =
      stepUpToken ||
      storageX.whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_KEYCLOAK).get();
    if (keycloakToken) {
      headers = headers.set("kc-auth", "Bearer " + keycloakToken);
    }

    return headers;
  }
}
